import React from 'react';
import { FormattedMessage } from 'react-intl';
import MarkReceivedButton from '../../components/grid-header/mark-received-button';
import { ShipmentsGridPrintDocumentButton } from '../../containers/print-document-button-containers/shipments-grid';
import { AssignToButtonContainer } from '../../containers/assign-to-button-container/assign-to-shipments';
import AssignToShipmentsMenuItems from '../../components/grid-header/assign-to-shipments-menu-items';
import VoidLabelButton from '../../components/grid-header/void-label-button';
import RefreshTrackingButton from '../../components/grid-header/refresh-tracking-button';
import { ExportShipmentsButton } from '../../components/grid-header/export-shipments-button';
import SendNotificationsButton from '../../components/grid-header/send-notifications-button';
import { CreateReturnButton } from '../../components/grid-header/create-return-button';
import NotifyMarketplaceButton from '../../components/grid-header/notify-marketplace-button';
import { ExcludeFromRefundButton } from '../../components/grid-header/exclude-from-refund-button';
import {
  SHIPPED_VIEW_ID,
  RECENT_VIEW_ID,
  IN_TRANSIT_VIEW_ID,
  DELIVERED_VIEW_ID,
  DELIVERY_EXCEPTION_VIEW_ID,
  RETURNS_VIEW_ID,
  VOIDED_VIEW_ID,
  ADVANCED_SEARCH_VIEW_ID,
  REFUND_ASSIST_VIEW_ID,
  PENDING_CUSTOMS_DOCUMENTS_VIEW_ID,
} from '../../components/shipping-grid/views/view-id-constants';

import messages from '../../components/grid-header/messages';

export const ExportShipmentsButtonId = 'exportShipments';
export const CreateReturnButtonId = 'createReturn';
export const SendNotificationsButtonId = 'sendNotifications';

const buttons = {
  assignTo: {
    type: AssignToButtonContainer,
    id: 'assignTo',
    overflowName: <FormattedMessage defaultMessage='Assign To' description='shippingGridActionBar.assignTo' id='iX/FzW' />,
    menu: AssignToShipmentsMenuItems,
  },
  markReceived: {
    type: MarkReceivedButton,
    id: 'markReceived',
    requiredRender: true,
  },
  print: {
    type: ShipmentsGridPrintDocumentButton,
    id: 'print',
    requiredRender: true,
  },
  voidLabel: {
    type: VoidLabelButton,
    id: 'voidLabel',
    overflowName: <FormattedMessage defaultMessage='Void Label' description='shippingGridActionBar.voidLabel' id='Ah/mzK' />,
  },
  refreshTracking: {
    type: RefreshTrackingButton,
    id: 'refreshTracking',
    overflowName: <FormattedMessage defaultMessage='Update Tracking' description='shippingGridActionBar.refreshTracking' id='ngEEs5' />,
  },
  exportShipments: {
    type: ExportShipmentsButton,
    id: ExportShipmentsButtonId,
    overflowName: <FormattedMessage defaultMessage='Export Shipments' description='shippingGridActionBar.exportShipments' id='hJGG3+' />,
  },
  sendNotifications: {
    type: SendNotificationsButton,
    id: SendNotificationsButtonId,
    overflowName: (
      <FormattedMessage defaultMessage='Send Notifications' description='shippingGridActionBar.sendNotifications' id='xJBHTr' />
    ),
  },
  createReturn: {
    type: CreateReturnButton,
    id: CreateReturnButtonId,
    overflowName: <FormattedMessage defaultMessage='Create Return' description='shippingGridActionBar.createReturn' id='AeV6OY' />,
  },
  notifyMarketplace: {
    type: NotifyMarketplaceButton,
    id: 'notifyMarketplace',
    overflowName: (
      <FormattedMessage defaultMessage='Notify Marketplace' description='shippingGridActionBar.notifyMarketplace' id='2V8MlU' />
    ),
  },
  excludeFromRefund: {
    type: ExcludeFromRefundButton,
    id: 'excludeFromRefund',
    overflowName: <FormattedMessage {...messages.excludeFromRefundButtonLabel} />,
  },
};

export const gridAvailableButtons = {
  [SHIPPED_VIEW_ID]: [
    buttons.print,
    buttons.voidLabel,
    buttons.refreshTracking,
    buttons.sendNotifications,
    buttons.notifyMarketplace,
    buttons.assignTo,
    buttons.createReturn,
    buttons.exportShipments,
  ],
  [RECENT_VIEW_ID]: [
    buttons.print,
    buttons.voidLabel,
    buttons.refreshTracking,
    buttons.sendNotifications,
    buttons.notifyMarketplace,
    buttons.assignTo,
    buttons.createReturn,
    buttons.exportShipments,
  ],
  [IN_TRANSIT_VIEW_ID]: [
    buttons.print,
    buttons.refreshTracking,
    buttons.sendNotifications,
    buttons.notifyMarketplace,
    buttons.createReturn,
    buttons.exportShipments,
  ],
  [DELIVERED_VIEW_ID]: [buttons.print, buttons.sendNotifications, buttons.notifyMarketplace, buttons.createReturn, buttons.exportShipments],
  [DELIVERY_EXCEPTION_VIEW_ID]: [
    buttons.print,
    buttons.refreshTracking,
    buttons.sendNotifications,
    buttons.notifyMarketplace,
    buttons.createReturn,
    buttons.exportShipments,
  ],
  [VOIDED_VIEW_ID]: [buttons.print, buttons.createReturn, buttons.exportShipments],
  [REFUND_ASSIST_VIEW_ID]: [
    buttons.print,
    buttons.refreshTracking,
    buttons.notifyMarketplace,
    buttons.assignTo,
    buttons.createReturn,
    buttons.excludeFromRefund,
  ],
  [RETURNS_VIEW_ID]: [buttons.markReceived, buttons.print],
  [PENDING_CUSTOMS_DOCUMENTS_VIEW_ID]: [
    buttons.print,
    buttons.voidLabel,
    buttons.refreshTracking,
    buttons.sendNotifications,
    buttons.notifyMarketplace,
    buttons.assignTo,
    buttons.createReturn,
    buttons.exportShipments,
  ],
  [ADVANCED_SEARCH_VIEW_ID]: [
    buttons.print,
    buttons.voidLabel,
    buttons.refreshTracking,
    buttons.sendNotifications,
    buttons.notifyMarketplace,
    buttons.assignTo,
    buttons.createReturn,
    buttons.exportShipments,
  ],
};
